import { ErrorBoundary } from './errorBoundary.js';
import { Validator } from './validation.js';

// Use global logger to avoid circular dependencies
const log = typeof window !== 'undefined' && window.Log ? window.Log('fetchCocktails') : {
  blue: () => {}, red: () => {}, green: () => {}, yellow: () => {}, purple: () => {}, log: () => {}, table: () => {}
};

export async function fetchCocktails(apiEndpoint) {
    log.green('Fetching cocktails from API');
    
    try {
        const response = await fetch(apiEndpoint);
        if (!response.ok) {
            const error = new Error(`HTTP error! status: ${response.status}`);
            error.type = response.status >= 500 ? 'api' : 'network';
            throw error;
        }
        
        const results = await response.json();

        log.blue('API response received, validating...');
        
        // Validate API response structure
        const validatedResponse = Validator.validateApiResponse(results);
        
        if (!validatedResponse.data.length) {
            const error = new Error('No valid cocktails in response after validation');
            error.type = 'api';
            throw error;
        }

        const cocktails = validatedResponse.data;
        
        log.green('Fetch and validation successful:', cocktails.length, 'cocktails');
        log.table('Sample validated cocktail:', cocktails[0]);
        
        return cocktails;
    } catch (error) {
        log.red('Fetch failed:', error);
        
        // Report to error boundary with context
        ErrorBoundary.reportError(error, 'fetchCocktails');
        
        // Enhance error with user-friendly messages
        if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
            error.message = 'Network connection error - please check your internet connection';
            error.type = 'network';
        } else if (error.name === 'ValidationError') {
            error.message = 'Server returned invalid data - please try again later';
            error.type = 'api';
        }
        
        throw error; // Let the component handle the error
    }
}
